import endpoint from "../../config/endpoints";

export const stackHolderRateStructureDetailsJson = {
  showSaveNextBtn: false,
  apiBaseURL: endpoint.productRateStructureAssignation,
  changeExcel: endpoint.exportData,
  isEditURL: endpoint.stackholder + "/update",
  //   formPathEdit: "/stock-holder-edit",
  //   openFormPath: "/stackholder-form-document",
  //   openFormPathStatus: "/stackholder-access-role",
  formPath: "/stackholder-form",
  screenTitle: false,
  searchButtonGrid: 1,
  showAddButton: false,
  showDeleteIcon: false,
  showPdfDownload: false,
  pdfFileName: "Stock Holder",
  showExcelDownload: false,
  excelFileName: "Stock Holder",
  excelUrl: "stock-holder-data-new",
  showBackToList: true,
};
